import { BreadcrumbService } from './../services/breadcrumb.service';
import { Component, AfterViewInit, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { IBreadcrumb } from './breadcrumb.interface';
import { ActivatedRoute, PRIMARY_OUTLET, Router, ActivatedRouteSnapshot } from '@angular/router';
import { CommonService } from '../services';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements AfterViewInit, OnInit, OnDestroy {
  public breadcrumbs: IBreadcrumb[];
  public previousUrl: string;
  readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  programName: string;
  opportunityName: string;
  renewalName: string;
  secondCapital: number[];
  @Input() lastRoute: string;
  @Output() notify: EventEmitter<string> = new EventEmitter<string>();

  @Input() inputbreadcrumbs: IBreadcrumb[];

  constructor(
    private cs: CommonService,
    private activeRouter: ActivatedRoute, 
    private router: Router,
    private breadcrumbService: BreadcrumbService) {
  }

  ngOnInit() {
    this.breadcrumbs = [];
    this.secondCapital = [];
    this.programName = "";
    this.renewalName = "";
  }

  ngAfterViewInit() {
    setTimeout(() => {
      let root: ActivatedRoute = this.activeRouter.root;
      //console.log(this.inputbreadcrumbs);
      if (this.inputbreadcrumbs) {
        this.breadcrumbs = this.inputbreadcrumbs;
      } else {
        this.breadcrumbs = this.getBreadcrumbs(root);
      }
      this.getCustomeBreadcrumb();      
    });
  }

  ngOnDestroy() {
    this.breadcrumbs = [];
  }

  /**
   * Originally copy from breve love's code
   * @param {ActivatedRoute} route
   * @param {string} url
   * @param {IBreadcrumb[]} breadcrumbs
   * @returns {IBreadcrumb[]}
   */
  private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    const ROUTE_DATA_BASEURL = 'baseUrl';
    var baseURL;

    // get the child routes
    const children: ActivatedRoute[] = route.children;

    // return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    // iterate over each children
    for (const child of children) {
      // verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      // verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(this.ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      //setup baseURL
      if (child.snapshot.data.hasOwnProperty(ROUTE_DATA_BASEURL)) {
        baseURL = child.snapshot.data[ROUTE_DATA_BASEURL];

        // get the route's URL segment
        const routeURL: string = child.snapshot.url.map(segment => segment.path).join(`/`);

        // append route URL to URL
        url += `/${baseURL}${routeURL}`;
      } else {
        const routeURL: string = child.snapshot.url.map(segment => segment.path).join(`/`);
        url += `/${routeURL}`;
      }

      // add breadcrumb
      const breadcrumb: IBreadcrumb = {
        label: this.parseBreadcrumb(child.snapshot),
        params: child.snapshot.params,
        url: url
      };

      breadcrumbs.push(breadcrumb);

      if (children.length !== 0) {
        if (child.snapshot.data[this.ROUTE_DATA_BREADCRUMB] === this.lastRoute) {
          return breadcrumbs;
        }
      }

      // recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  getCustomeBreadcrumb() {
        //add custom breadcrumb by breadcrumbservice
        this.breadcrumbService.breadcrumbChanged.subscribe(value => {
          //this.breadcrumbs = this.breadcrumbService.getBreadcrumb();
          if(this.router.url.includes("buy")){
            this.breadcrumbs = [];
          }
          value.forEach(item => {
            if (this.breadcrumbs.filter(i => i.label == item.label).length == 0)
              this.breadcrumbs.push(item)
            });
  
          this.breadcrumbs.map(i => i.url = this.cs.DDskuDecode(i.url));
        });
  }

  parseBreadcrumb(snapshot: ActivatedRouteSnapshot) {
    // Manually set the 'data' to 'sku' or 'id'. when meet this condition, fetch the last path of Url and render in into the breadcrumb. For example: product sku, newsletter id.
    if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'sku') {
      return this.cs.DDskuDecode(snapshot.params["sku"]);
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'id') {
      return snapshot.params["id"];
    }else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'ProductSku') {
      return snapshot.params["ProductSku"];
    }else if(snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'renewalProgramName') {
      return snapshot.params["renewalProgramName"]; 
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'cartName') {
      return this.cs.DDskuDecode(snapshot.params["cartName"]);
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'vendorName') {
      return this.cs.DDskuDecode(snapshot.params["vendorName"]);
    }else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'programType') {
      this.programName = snapshot.params["programType"];
      let vendorDetais = JSON.parse(localStorage.getItem('subscriptionVendor'));
      if (vendorDetais.length) {
        let filteredVendor = vendorDetais.filter(x => x.programType == snapshot.params["programType"]);

        if (filteredVendor.length) {
          this.programName = filteredVendor[0].programName;
        }
      } 
      
      return this.programName.trim();
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'renewalType') {
      this.renewalName = "";
      let renewalDetais = JSON.parse(localStorage.getItem('renewalPrograms'));
      this.renewalName = renewalDetais.filter(x => x.programType == snapshot.params["renewalType"])[0].programName;
      return this.renewalName.trim();
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'promoType') {
      if (snapshot.params["promoType"] == "Edit") {
        return "Edit Promotion";
      } else {
        return "New Promotion";
      }
    } else if(snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'reportType') {
      return snapshot.params["reportType"].match(/[A-Z][a-z]+|[0-9]+/g).join(" "); 
    } else if(snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'customerId') {
      return snapshot.params["customerId"]; 
    } else if(snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'tenantId') {
      return snapshot.params["tenantId"]; 
    } else if(snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'opportunityName') {
      this.opportunityName = "";
      let opportunity = JSON.parse(localStorage.getItem('opportunityName'));
      this.opportunityName = opportunity[0].accounts.end_customer.account.name
      return this.opportunityName.trim();
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'opportunityId') {
      return snapshot.params["opportunityId"];
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'orderNo') {
      return snapshot.params["orderNo"];
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'vendorAgreementNo') {
      return snapshot.params["vendorAgreementNo"];
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'searchOppId') {
      return snapshot.params["searchOppId"];
    } else if (snapshot.data[this.ROUTE_DATA_BREADCRUMB] === 'budgetName') {
      return snapshot.params["budgetName"];
    } else{
      return snapshot.data[this.ROUTE_DATA_BREADCRUMB];
    }
  }

  onClick() {
    this.notify.emit('clicked');
  }

  isUpperCase(aCharacter) {
    return (aCharacter >= 'A') && (aCharacter <= 'Z');
  }
}
